export default "__VITE_ASSET__C7lqfu16__"